import React from 'react';
import PropTypes from 'prop-types';

/**
 * BtnUpdate
 */
class BtnUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.clickApply = this.clickApply.bind(this);
    this.clickReset = this.clickReset.bind(this);
  }

  /**
   * 反映ボタン押下
   */
  clickApply() {
    if (document.getElementById("search") != null) {
      document.getElementById('search').value = '';
    }

    $('#filter_form').hide();
    this.props.actions.applyFilterForm();
  }

  /**
   * リセットボタン押下
   */
  clickReset() {
    this.props.actions.clickUpdate();
  }

  render() {
    return (
      <div className="ctrl_form_bottom_area">
        <div className="ctrl_form_bottom_reset content_item_border_default" onClick={() => this.clickReset()}>
          <span>
            リセット
          </span>
        </div>
        <div className="ctrl_form_bottom_apply content_item_border_default" onClick={() => this.clickApply()}>
          <span>
            反映
          </span>
        </div>
      </div>
    );
  }
}

BtnUpdate.propTypes = {
  actions: PropTypes.any.isRequired
};

export default BtnUpdate;
